import apiClient from "./apiClient";
import { decodeBase64Json } from "../utils/decodeBase64Json";

export const createTicket = async (ticketData) => {
  const payload = {
    title: String(ticketData.title || ""),
    description: String(ticketData.description || ""),
    enum_ticket_priority_id: String(ticketData.enum_ticket_priority_id || ""),
    enum_ticket_source_id: String(ticketData.enum_ticket_source_id || ""),
    lt_ticket_category_id: String(ticketData.lt_ticket_category_id || ""),
    remarks: String(ticketData.remarks || ""),
  };

  const response = await apiClient.post(
    "/DS/admin_center/create_ticket.zjs",
    payload
  );

  return response.data;
};

export const getTickets = async () => {
  const response = await apiClient.post(
    "/DS/admin_center/get_tickets.zjs",
    {}
  );

  return response.data;
};

export const getTicketComments = async (ticketId) => {
  const response = await apiClient.post(
    "/DS/admin_center/get_ticket_comments.zjs",
    {
      ticket_id: String(ticketId),
    }
  );

  const base64 = response?.data?.[0]?.BASE64_RESULT;

  if (!base64) {
    // اگر خود response.data آرایه کامنت‌هاست، همان را برگردان
    if (Array.isArray(response.data)) return response.data;
    if (Array.isArray(response.data?.RQ)) return response.data.RQ;
    if (Array.isArray(response.data?.RQS)) return response.data.RQS;
    return response.data;
  }

  const decoded = decodeBase64Json(base64);
  // اول RQ، بعد RQS، بعد اگر خود decoded آرایه بود، همان
  if (Array.isArray(decoded?.RQ)) return decoded.RQ;
  if (Array.isArray(decoded?.RQS)) return decoded.RQS;
  if (Array.isArray(decoded)) return decoded;

  return decoded;
};


export const getTicketDetails = async (ticketId) => {
  const tickets = await getTickets();

  const ticket = Array.isArray(tickets)
    ? tickets.find((item) => String(item.TICKET_ID) === String(ticketId))
    : null;

  const comments = await getTicketComments(ticketId);

  return {
    ticket,
    comments,
  };
};

export const sendTicketReply = async (
  ticketId,
  message,
  parentId = null,
  attachment = null
) => {
  const payload = {
    ticket_id: String(ticketId),
    comment_text: String(message || ""),
    is_customer: "true",
    parent_comment_id: parentId ? String(parentId) : "",
  };

  const response = await apiClient.post(
    "/DS/admin_center/add_ticket_comments.zjs",
    payload
  );

  return response.data;
};
